import BoardContentInformationApi from '@app/api/public/BoardContentInformationApi';
import { useQuery } from 'react-query';

export const boardInformationQueryKeys = {
    all: [{ scope: 'boardInformation' }] as const,
    lists: () => [{ ...boardInformationQueryKeys.all[0], entity: 'list' }] as const,
    list: (type: 'draft' | 'published') => [{ ...boardInformationQueryKeys.lists()[0], type }] as const,
    details: () => [{ ...boardInformationQueryKeys.all[0], entity: 'detail' }] as const,
    detail: (id: number) => [{ ...boardInformationQueryKeys.details()[0], id }] as const,
    documents: () => [{ ...boardInformationQueryKeys.all[0], entity: 'document' }] as const,
    document: (id: number) => [{ ...boardInformationQueryKeys.documents()[0], id }] as const,
};

const getPageListItems = async (type: 'draft' | 'published') => {
    return await BoardContentInformationApi.list(type);
};

const useGetContentInformationList = (type: 'draft' | 'published') => {
    return useQuery({
        queryFn: ({ queryKey }) => {
            const { type } = queryKey[0];
            return getPageListItems(type);
        },
        queryKey: boardInformationQueryKeys.list(type),
    });
};

const getContentInformation = (id: number) => {
    return BoardContentInformationApi.get(id);
};

const useGetBoardInformationById = (id: number) => {
    return useQuery({
        queryFn: ({ queryKey }) => getContentInformation(queryKey[0].id),
        queryKey: boardInformationQueryKeys.detail(id),
        enabled: !!id,
    });
};

export { useGetContentInformationList, useGetBoardInformationById };
